import { render, staticRenderFns } from "./ConfigurationMovementSchemaTable.vue?vue&type=template&id=5c7d17b0&"
import script from "./ConfigurationMovementSchemaTable.vue?vue&type=script&lang=js&"
export * from "./ConfigurationMovementSchemaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports